module.exports = __webpack_public_path__ + "static/media/Chalkduster.a5c61d55.ttf";